import React from "react";
import classes from './ContentStteper.module.css'

const StepperContent = ({ currentStep, validChildren, setCurrentStep, goToNextStep }) => {

    const currentChild = validChildren[currentStep];

    if (!currentChild?.props?.children)
        return null;

    return (
        <div className={classes.Content}>
            {React.Children.map(currentChild.props.children, (child) =>
                React.isValidElement(child) ?
                    React.cloneElement(child, { changeCurrentStep: (index) => setCurrentStep(index), goToNextStep, })
                    : child
            )}
        </div>
    );
};
export default StepperContent